import reviewDeliveryPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/reviewDeliveryPayloadSchema';
import { REVIEW_DELIVERY_INTERNAL } from 'root/src/shared/descriptions/endpoints/endpointIds';
export const payloadSchema = reviewDeliveryPayloadSchema;
export default {
    [REVIEW_DELIVERY_INTERNAL]: {
        payloadSchema,
    },
};
